import { createStyles, makeStyles } from "@material-ui/core";
import { CandidateVerificationStatus } from "../../domain";
import * as React from "react";

import {
    AwaitingVerificationStatusBadge,
    VerificationDeniedStatusBadge,
    VerificationVerifiedStatusBadge,
} from "../../assets/statusBadges";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        root: {},
    })
);

export interface CandidateVerificationStatusLabelProps {
    verificationStatus: number | CandidateVerificationStatus;
    id?: string;
    className?: string;
    title?: string;
}

export const CandidateVerificationStatusLabel = (
    props: CandidateVerificationStatusLabelProps
) => {
    const { verificationStatus, ...rest } = props;

    const status =
        verificationStatus instanceof CandidateVerificationStatus
            ? verificationStatus
            : CandidateVerificationStatus.fromId(verificationStatus);
    switch (status) {
        case CandidateVerificationStatus.Awaiting:
            return <AwaitingVerificationStatusBadge {...rest} />;
        case CandidateVerificationStatus.Verified:
            return <VerificationVerifiedStatusBadge {...rest} />;
        case CandidateVerificationStatus.Denied:
            return <VerificationDeniedStatusBadge {...rest} />;
        default:
            return null;
    }
};
